/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  FormItem, ItemLabel, RadioButton, RadioButtonText,
} from './Forms';
import { ProspectType } from '../types';
import ProspectAdditionalInfo from './steps/ProspectAdditionalInfo';

const SelectProspectType = ({ FIELD }) => {
  const { t } = useTranslation();

  return (
    <>
      <FormItem
        marginBottom="-16px"
        labelCol={{ span: 24 }}
        label={(<ItemLabel>{t('FORM_FILL_COMPANY.PROSPECT_TYPE_HEADER')}</ItemLabel>)}
        name={FIELD.PROSPECT_TYPE}
        rules={[{
          required: true,
          message: '',
        }]}
      >
        <Radio.Group>
          <RadioButton value={ProspectType.SHIPPER}>
            <RadioButtonText style={t('FORM_FILL_COMPANY.SHIPPER_PROSPECT_ADDITIONAL_INFO') ? {} : { height: '44px' }}>
              {t('FORM_FILL_COMPANY.SHIPPER_PROSPECT')}
              {
                t('FORM_FILL_COMPANY.SHIPPER_PROSPECT_ADDITIONAL_INFO')
                  ? (<ProspectAdditionalInfo text={t('FORM_FILL_COMPANY.SHIPPER_PROSPECT_ADDITIONAL_INFO')} />)
                  : (<></>)
              }
            </RadioButtonText>
          </RadioButton>
          <RadioButton value={ProspectType.CARRIER}>
            <RadioButtonText>
              {t('FORM_FILL_COMPANY.CARRIER_PROSPECT')}
              <ProspectAdditionalInfo text={t('FORM_FILL_COMPANY.CARRIER_PROSPECT_ADDITIONAL_INFO')} />
            </RadioButtonText>
          </RadioButton>
          <RadioButton value={ProspectType.FORWARDER}>
            <RadioButtonText>
              {t('FORM_FILL_COMPANY.FORWARDER_PROSPECT')}
              <ProspectAdditionalInfo text={t('FORM_FILL_COMPANY.FORWARDER_PROSPECT_ADDITIONAL_INFO')} />
            </RadioButtonText>
          </RadioButton>
        </Radio.Group>
      </FormItem>
    </>
  );
};

export default SelectProspectType;

SelectProspectType.propTypes = {
  FIELD: PropTypes.any.isRequired,
};
